import { useCallback } from 'react';

import { usePlatformConfig } from '@/hooks';

import styles from './index.module.less';

export const Integrated = ({ style }: { style?: React.CSSProperties }) => {
  const { platformConfig } = usePlatformConfig();
  const onClick = useCallback(() => {
    window.open('https://beian.mps.gov.cn/#/query/webSearch', '_blank');
  }, []);

  return (
    <div className={styles['integrated-info']} style={style}>
      <span onClick={onClick}>{platformConfig.recordNumber}</span>
    </div>
  );
};
